<template>
  <v-card outlined class="card">
    <v-card-title>
        Issues Colors
        <v-icon class="setting-scope-icon">mdi-account</v-icon>
    </v-card-title>
    <v-divider />
    <v-card-text class="card-body">
        <v-row>

        <v-col cols="12">
            <!-- <span>These settings are stored in your profile on the server and will be applied whenever you log in from any computer</span> -->
            <h3>Use Alarm Colors</h3>
            <v-switch v-model="colors.useAlarmColors" label="No/Yes" color="#c42111" />
        </v-col>

        <v-col cols="12" md="6">
            <v-card outlined>
                <span style="font-size: 11pt; display: block" class="ml-4 mt-2">Critical</span>
                <v-card-text class="pt-1">
                    <v-btn :color="colors.critical.new.background" :style="{color: colors.critical.new.foreground}" class="mr-3" width="100" @click="editColor('critical', 'new')" :disabled="colors.useAlarmColors">New</v-btn>
                    <v-btn :color="colors.critical.acked.background" :style="{color: colors.critical.acked.foreground}" class="mr-3" width="100" @click="editColor('critical', 'acked')" :disabled="colors.useAlarmColors">Acked</v-btn>
                    <v-btn :color="colors.critical.cleared.background" :style="{color: colors.critical.cleared.foreground}" width="100" @click="editColor('critical', 'cleared')" :disabled="colors.useAlarmColors">Cleared</v-btn>
                </v-card-text>
            </v-card>
        </v-col>

        <v-col cols="12" md="6">
            <v-card outlined>
                <span style="font-size: 11pt; display: block" class="ml-4 mt-2">Major</span>
                <v-card-text class="pt-1">
                    <v-btn :color="colors.major.new.background" :style="{color: colors.major.new.foreground}" class="mr-3" width="100" @click="editColor('major', 'new')" :disabled="colors.useAlarmColors">New</v-btn>
                    <v-btn :color="colors.major.acked.background" :style="{color: colors.major.acked.foreground}" class="mr-3" width="100" @click="editColor('major', 'acked')" :disabled="colors.useAlarmColors">Acked</v-btn>
                    <v-btn :color="colors.major.cleared.background" :style="{color: colors.major.cleared.foreground}" width="100" @click="editColor('major', 'cleared')" :disabled="colors.useAlarmColors">Cleared</v-btn>
                </v-card-text>
            </v-card>
        </v-col>

        <v-col cols="12" md="6">
            <v-card outlined>
                <span style="font-size: 11pt; display: block" class="ml-4 mt-2">Minor</span>
                <v-card-text class="pt-1">
                    <v-btn :color="colors.minor.new.background" :style="{color: colors.minor.new.foreground}" class="mr-3" width="100" @click="editColor('minor', 'new')" :disabled="colors.useAlarmColors">New</v-btn>
                    <v-btn :color="colors.minor.acked.background" :style="{color: colors.minor.acked.foreground}" class="mr-3" width="100" @click="editColor('minor', 'acked')" :disabled="colors.useAlarmColors">Acked</v-btn>
                    <v-btn :color="colors.minor.cleared.background" :style="{color: colors.minor.cleared.foreground}" width="100" @click="editColor('minor', 'cleared')" :disabled="colors.useAlarmColors">Cleared</v-btn>
                </v-card-text>
            </v-card>
        </v-col>

        <v-col cols="12" md="6">
            <v-card outlined>
                <span style="font-size: 11pt; display: block" class="ml-4 mt-2">Observational</span>
                <v-card-text class="pt-1">
                    <v-btn :color="colors.observational.new.background" :style="{color: colors.observational.new.foreground}" class="mr-3" width="100" @click="editColor('observational', 'new')" :disabled="colors.useAlarmColors">New</v-btn>
                    <v-btn :color="colors.observational.acked.background" :style="{color: colors.observational.acked.foreground}" class="mr-3" width="100" @click="editColor('observational', 'acked')" :disabled="colors.useAlarmColors">Acked</v-btn>
                    <v-btn :color="colors.observational.cleared.background" :style="{color: colors.observational.cleared.foreground}" width="100" @click="editColor('observational', 'cleared')" :disabled="colors.useAlarmColors">Cleared</v-btn>
                </v-card-text>
            </v-card>
        </v-col>

        <v-col cols="12">
            <div>
                <v-color-picker light v-model="edit.background" :width="colorPickerWidth" v-if="!editForeground" :disabled="colors.useAlarmColors"></v-color-picker>
                <v-color-picker light v-model="edit.foreground" :width="colorPickerWidth" v-if="editForeground" :disabled="colors.useAlarmColors"></v-color-picker>
                <span class="color-picker-label">{{editText}}&nbsp;</span>
                <v-menu offset-y v-if="editText">
                    <template v-slot:activator="{ on }">
                        <span class="color-picker-label select" v-on="on">{{('• ' + (editForeground ? 'foreground' : 'background'))}}<v-icon color="#2196F3" size="18">mdi-menu-swap-outline</v-icon></span>
                    </template>
                    <v-list>
                        <v-list-item :key="'background'" @click="editForeground = false">
                            <v-list-item-title>BACKGROUND</v-list-item-title>
                        </v-list-item>
                        <v-list-item :key="'foreground'" @click="editForeground = true">
                            <v-list-item-title>FOREGROUND</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </div>
        </v-col>

        </v-row>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
        <v-btn text @click="restoreDefaultColors">Restore Defaults</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { defaultBaseSettings } from "@/./defaultWebappSettings";
export default {
    name: 'IssuesColors',
    props: ['issuesColors'],
    components: {

    },
    data: () => ({
        edit: {background: '', foreground: ''},
        editText: '',
        editForeground: false,
        colors: null,
    }),

    computed: {
        colorPickerWidth: function() {
            let w = window.innerWidth - 160;
            return ((w > 730) ? 730 : w);
        }
    },

    methods: {
        editColor: function(severity, status) {
            this.edit = this.colors[severity][status];
            this.editText = `${severity} • ${status}`;
        },

        restoreDefaultColors: function() {
            let defaults = JSON.parse(JSON.stringify(defaultBaseSettings.issues.issuesColors));
            this.colors.critical = defaults.critical;
            this.colors.major = defaults.major;
            this.colors.minor = defaults.minor;
            this.colors.observational = defaults.observational;
        }
    },

    created() {
        this.colors = this.$props.issuesColors;
    }

  
}
</script>

<style scoped>

    .color-picker-label {
        text-transform: uppercase;
        text-align: center;
        font-size: 12pt;
        margin-top: 1em;
        display: inline-block;
        position: relative;
    }
    .color-picker-label.select {
        color: #2196F3;
        cursor: pointer;
    }

    .color-picker-label.select i {
        vertical-align: text-top;
    }

</style>
